class Countdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.buyBtn = document.querySelector("[data-block-type='buy-buttons']");
    this.container = this.querySelector(".countdown_container");
    this.hourEl = this.querySelector(
      ".countdown_sale-countdown-timer__hours-number"
    );
    this.minuteEl = this.querySelector(
      ".countdown_sale-countdown-timer__minutes-number"
    );
    this.secondEl = this.querySelector(
      ".countdown_sale-countdown-timer__seconds-number"
    );

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  getCurrentTime() {
    return new Date().getTime();
  }

  getEndDate() {
    return new Date(window.mb?.countdown?.endDate).getTime();
  }

  calculateTime(milliseconds) {
    let hours = Math.floor(milliseconds / (60 * 60 * 1000));
    milliseconds -= hours * 60 * 60 * 1000;
    let minutes = Math.floor(milliseconds / (60 * 1000));
    milliseconds -= minutes * 60 * 1000;
    let seconds = Math.floor(milliseconds / 1000);

    return {
      hours: hours < 10 ? `0${hours}` : `${hours}`,
      minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
      seconds: seconds < 10 ? `0${seconds}` : `${seconds}`,
    };
  }

  hideCountdown() {
    if (this.container) {
      this.container.classList.add("hidden");
    }
    if (this.hourEl) this.hourEl.innerText = "00";
    if (this.minuteEl) this.minuteEl.innerText = "00";
    if (this.secondEl) this.secondEl.innerText = "00";
  }

  showCountdown() {
    this.container?.classList.remove("hidden");
  }

  hideBuyButton() {
    this.buyBtn.classList.add("hidden");
  }

  showBuyButton() {
    this.buyBtn.classList.remove("hidden");
  }

  updateCountdown() {
    const now = this.getCurrentTime();
    const remaining = this.getEndDate() - now;

    if (remaining <= 0) {
      this.hideCountdown();
      this.showBuyButton();
      clearInterval(this.interval);
    } else {
      this.showCountdown();
      this.hideBuyButton();
      const time = this.calculateTime(remaining);
      this.hourEl.innerText = time.hours;
      this.minuteEl.innerText = time.minutes;
      this.secondEl.innerText = time.seconds;
    }
  }
}

customElements.define("product-countdown", Countdown);
